import HttpRequest from '@/libs/axios'
import config from '@/config'

const axios = new HttpRequest(config.baseUrl)
export default axios

export const ajax = (url, method, params, data) =>
  axios.request({
    url,
    method,
    params,
    data
  })

export const get = (url, params) =>
  ajax(url, 'get', params)

export const post = (url, data) =>
  ajax(url, 'post', undefined, data)

export const del = (url) =>
  ajax(url, 'delete')

export const put = (url, data) =>
  ajax(url, 'put', undefined, data)
